// React
import React from "react";

// Styles
import './refreshButton.css';

/*
 * Props 
 * @value : displayed valued in dropdown
 * @icon : 
 * @children : the list elements
 * @dropdownClasses
*/
const RefreshButton = (props) => {

    return (
        <div className='refreshing' onClick={props.onClick}>
            <div>
                <i className="icon-reload-alt" ></i>
            </div>
        </div>
    );


};

export default RefreshButton;

/*<div className='groovy-button' onClick={props.onClick}>
            <div className="button-parent purple-button">
        
                <div className="circle circle-3">
                    <div className="circle circle-2">
                        <div className="circle circle-1">
                            <i className="icon-reload-alt text-white" ></i>
                        </div>
                    </div>
                </div>
            
            </div>
        </div>*/


// WEBPACK FOOTER //
// ./src/Components/RefreshButton/RefreshButton.js